import { render, staticRenderFns } from "./RestrictedEnrollmentMessage.vue?vue&type=template&id=30b722bf&scoped=true&"
import script from "./RestrictedEnrollmentMessage.vue?vue&type=script&lang=ts&"
export * from "./RestrictedEnrollmentMessage.vue?vue&type=script&lang=ts&"
import style0 from "./RestrictedEnrollmentMessage.vue?vue&type=style&index=0&id=30b722bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b722bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
